// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wwE5m","type":"styles_type__3lfy_","choices":"styles_choices__1GJwo"};